import { render, staticRenderFns } from "./SalesReportWith.vue?vue&type=template&id=60afba3c&"
import script from "./SalesReportWith.vue?vue&type=script&lang=ts&"
export * from "./SalesReportWith.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports